<template>
  <div class="operation-panel bg-transparent rounded-2px z-99 w-full h-full">
    <div class="search-wrap flex items-center">
      <el-select
        v-model="searchData.deviceName"
        size="small"
        class="w-120px"
        ref="fatherNode"
        popper-class="visualization-select-popper"
        placeholder="请选择装置"
        filterable
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          prefix-icon="el-icon-search"
          v-model="treeFilterKey"
          size="mini"
          clearable
        ></el-input>
        <el-option
          hidden
          key="id"
          :label="searchData.deviceName"
          :value="searchData.deviceName"
        ></el-option>
        <el-tree
          v-loading="deviceTreeLoading"
          ref="smallTreeDom"
          :data="treeData"
          empty-text="暂无数据"
          highlight-current
          :props="defaultTreeProps"
          :expand-on-click-node="false"
          :default-expand-all="false"
          :filter-node-method="filterTreeNode"
          @node-click="treeSelect"
          class="device-tree text-14px"
        >
        </el-tree>
      </el-select>
      <el-input
        size="small"
        v-model="searchData.keyWord"
        placeholder="请输入盲板编码"
        clearable
        class="ml-5px w-160px"
      ></el-input>
      <el-button @click="searchHandler" size="mini" type="primary" class="ml-5px">搜索</el-button>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      :row-key="(row) => row.id"
      class="markerTable"
      height="calc(100% - 90px)"
      highlight-current-row
      @row-click="rowClick"
      v-loading="tableLoading"
    >
      <el-table-column show-overflow-tooltip prop="code" label="盲板编码"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="{ row }">
          <span class="text-[#15cee9] cursor-default" @click.stop="checkDetail(row)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { map, isEmpty, forEach, find, filter } from 'lodash'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import { ModelApi } from '@wiz-api/material-management'

const modelApi = new ModelApi()
const threeDimensionsApi = new ThreeDimensionsApi()

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    deviceInfo: {
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      deviceTreeLoading: false,
      deviceChange: false, // 是否是装置切换，用于创建图表
      createMarkStep: 1, // 创建图标的步骤，装置切换时使用（获取列表和模型加载完成顺序不定）
      treeFilterKey: null,
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      searchData: {
        deviceName: null,
        keyWord: null,
      },
      defaultTreeProps: {
        children: 'children',
        label: 'deviceName',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      treeData: [], // 装置treeData
      tableData: [],
      markerCollection: [],
    }
  },
  watch: {
    treeFilterKey(val) {
      this.$refs.smallTreeDom.filter(val)
    },
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async created() {
    // 装置
    this.getDeviceList()
    this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
  },
  methods: {
    // 获取装置下拉列表
    async getDeviceList() {
      this.deviceTreeLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceList({
        isTree: true,
        body: {
          name: null,
        },
      })
      this.deviceTreeLoading = false
      if (!err && res) {
        const filterTree = (nodes) => {
          const filterNode = (node) => {
            if (!node.modelId) {
              return null
            }
            if (node.children && node.children.length > 0) {
              const filteredChildren = node.children.map(filterNode).filter((child) => {
                return child !== null
              })
              node.children = filteredChildren.length > 0 ? filteredChildren : []
            }

            return node
          }
          return nodes.map(filterNode).filter((node) => {
            return node !== null
          })
        }
        this.treeData = filterTree(res)
        if (res.length) {
          if (this.deviceInfo.deviceId) {
            this.searchData.deviceName = this.deviceInfo.deviceName
            this.currentDeviceId = this.deviceInfo.deviceId
            this.currentModelId = this.deviceInfo.modelId
          } else {
            this.searchData.deviceName = res[0].deviceName
            this.currentDeviceId = res[0].id
            this.currentModelId = res[0].modelId
          }
          this.searchData.keyWord = null
          this.searchHandler() // 获取全场管线数据
        }
      }
    },
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 装置树选择
    treeSelect(data) {
      if (!data.modelId) {
        this.$message.warning('该装置未绑定模型')
        return
      }
      if (this.currentDeviceId === data.id) {
        console.log('same device')
        return
      }
      this.createMarkStep = 0 // 开始切换
      this.$emit('loadingSwitch', { bol: true, title: '正在切换装置' })
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      this.searchData.deviceName = data.deviceName
      this.currentDeviceId = data.id
      this.currentModelId = data.modelId
      this.$emit('updateDeviceInfo', {
        deviceName: data.deviceName,
        deviceId: data.id,
        modelId: data.modelId,
      })
      this.$refs.fatherNode.blur()
      this.tableData = [] // 清空表单
      this.searchData.keyWord = null
      this.getModelDetail() // 获取模型详情
      this.searchHandler() // 获取管线列表
    },
    // 获取模型详情信息
    async getModelDetail() {
      const [err, res] = await modelApi.get(this.currentModelId)
      if (!err && res?.medias) {
        const modelInfo = _.find(res.medias, ['mediaType', 1])
        const textureInfo = _.find(res.medias, ['mediaType', 2])
        if (modelInfo?.fileInfoId) {
          const modelDetail = {
            filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.pr`,
            materialFileId: textureInfo ? textureInfo.fileInfoId : '',
            modelFileId: modelInfo.fileInfoId,
          }
          this.$emit('changeModel', modelDetail)
        } else {
          this.$message.warning('模型文件不存在')
        }
      }
    },
    // 监听模型切换加载完成操作
    checkModelLoadEnd(value, handle, name) {
      this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
      if (this.createMarkStep === 0) {
        this.createMarkStep = 1
      } else {
        const needRenderData = filter(this.tableData, (item) => {
          return item.pointId && item.isShow
        })
        if (needRenderData.length) {
          this.batchAddMarker(needRenderData)
        }
      }
    },
    // 获取盲板数据
    async getTableData() {
      await this.batchDestroyMarker()
      this.tableLoading = true
      const [err, res] = await threeDimensionsApi.getBlindPlateList({
        body: {
          code: this.searchData.keyWord,
          maxResultCount: this.page.pageSize,
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
          id: null,
          deviceId: this.currentDeviceId,
          isValid: 1,
        },
      })
      this.tableLoading = false
      let needRenderData = []
      if (!err && res && res.code === '0' && res.data?.items) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
        if (this.createMarkStep === 0) {
          // 模型未加载结束，不创建
          this.createMarkStep = 1
        } else {
          needRenderData = filter(this.tableData, (item) => {
            return item.pointId && item.isShow
          })
          if (needRenderData.length) {
            this.batchAddMarker(needRenderData)
          }
        }
      }
    },
    // 图标点击
    markerClick(data) {
      const markerInfo = find(this.markerCollection, ['markerId', data.markerId])
      if (markerInfo) {
        const detail = find(this.tableData, ['id', markerInfo.id])
        if (detail) {
          const filterEvent = new CustomEvent('gxDialogControl', {
            detail: {
              ...detail,
              currentDialog: 'blindPlate',
            },
          })
          window.dispatchEvent(filterEvent)
        }
      }
    },
    /**
     * @description 批量创建图标
     */
    // eslint-disable-next-line consistent-return
    async batchAddMarker(needRenderData) {
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      if (!rootItems.length) {
        return false
      }
      const relationGroup = []
      for (let i = 0; i < needRenderData.length; i += 1) {
        relationGroup.push({
          // eslint-disable-next-line no-await-in-loop
          imgId: await this.player.Native.GisMarker.loadImage(
            `data://../apps/${this.modelSetting.folderName}/icon/${needRenderData[i].icon}.png`
          ),
          id: needRenderData[i].id,
          pos: JSON.parse(needRenderData[i].position),
        })
      }
      await Promise.all(relationGroup)
      const paramCollection = []
      forEach(relationGroup, (item) => {
        paramCollection.push({
          pos: item.pos, // '定位点，世界坐标，三维向量，默认值为[0, 0, 0]'
          visible: true, // '显示隐藏状态，boolean类型，默认值为true'
          size: -1, // '整体尺寸，二维向量，分别表示宽高，-1表示不限制（自动计算图标和文字大小）
          nodeOffset: [-22, -65],
          imgId: item.imgId, // '图片id，整数，0表示不显示图片'
          imgSize: [45, 65], // '图片显示大小
        })
      })
      const markerIds = await this.player.Native.GisMarker.batchCreate(paramCollection)
      for (let i = 0; i < markerIds.length; i += 1) {
        this.markerCollection.push({
          markerId: markerIds[i],
          id: relationGroup[i].id,
          pos: relationGroup[i].pos,
        })
      }
    },
    // 批量销毁
    async batchDestroyMarker() {
      if (!isEmpty(this.markerCollection)) {
        const markerIds = map(this.markerCollection, 'markerId')
        await this.player.Native.GisMarker.batchDestroy(markerIds)
      }
      this.markerCollection = this.$options.data().markerCollection
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 查看详情
    async checkDetail(row) {
      const filterEvent = new CustomEvent('gxDialogControl', {
        detail: {
          ...row,
          currentDialog: 'blindPlate',
        },
      })
      window.dispatchEvent(filterEvent)
    },
    async rowClick(row) {
      let nodePtr = 0
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      if (rootItems.length) {
        nodePtr = rootItems[0].nodePtr
      }
      if (row.pointId && nodePtr) {
        this.player.Native.Camera.moveToPos(JSON.parse(row.position), nodePtr, 5, 1)
      }
    },
  },
  async beforeDestroy() {
    await this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
    await this.batchDestroyMarker()
  },
}
</script>
<style lang="scss">
.visualization-select-popper {
  .el-select-dropdown__list {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.operation-panel {
  .search-wrap {
    ::v-deep .el-button {
      height: 28px !important;
      line-height: 28px !important;
      border-radius: 5px !important;
    }
  }

  .markerTable {
    margin-top: 10px;

    ::v-deep .el-table th.is-leaf,
    .el-table td {
      border: none !important;
    }
  }
}
::v-deep.device-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #0499a744 !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #049aa780 !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #049aa780 !important;
  }
  .el-tree-node__label {
    color: #fff !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
